<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
  <dx-lookup
    [label]="'common.tabTitle.operationTypes' | translate | ucfirst"
    [gsResource]="operationTypes"
    formControlName="operationTypeId"
    displayExpr="name"
    valueExpr="id"
    formField required
    (onValueChanged)="onOperationTypeValueChanged($event.value)"
  />

  <dx-text-box [label]="'common.name' | translate | ucfirst" formControlName="name" formField required></dx-text-box>

  <dx-lookup [gsResource]="workProcedures"
    [label]="'menu.breadcrumb.workProcedures' | translate | ucfirst"
    formControlName="workProcedureId"
    displayExpr="name"
    valueExpr="id"
    formField
  />
</form>